import React from "react";
import { v4 as uuidv4 } from "uuid";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import SubscriptionBox from "./SubscriptionBox";
import TopicsCovered from "./TopicsCovered";
import TableOfContent from "./TableOfContent";
import { getHideContent } from "./utils";
import * as S from "./ArticleContent.sc";
import Ado from "../Ado/Ado";
import AdoCodes from "../Ado/AdoConfig.json";

const BlurText = styled.p`
  color: transparent;
  text-shadow: 0 0 5px rgba(121, 121, 121, 1);
  filter: blur(2px);
`;

const ArticleHideContent = ({ article, topics, tableOfContentData }) => {
  const hideContent =
    article.body_split.length > 1
      ? getHideContent(article.body_split.slice(1))
      : [];
  return (
    <>
      <div className="wysiwyg">
        {topics || tableOfContentData ? (
          <S.LeftBoxContaiener>
            {topics && <TopicsCovered topics={topics} />}
            {tableOfContentData && (
              <TableOfContent content={tableOfContentData} />
            )}
          </S.LeftBoxContaiener>
        ) : null}
        {ReactHtmlParser(article.body_split[0])}
        <S.BoxContaiener>
          <Ado {...AdoCodes.id01articleInContent} />
        </S.BoxContaiener>
      </div>
      <SubscriptionBox />
      {hideContent.map((el) => (
        <BlurText key={uuidv4()}>{el}</BlurText>
      ))}
    </>
  );
};

export default ArticleHideContent;
